let activeRequestCount = 0;
const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach((listener) => listener());
};

export const getRequestActivitySnapshot = () => activeRequestCount > 0;

export const subscribeRequestActivity = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const beginRequest = () => {
  let released = false;
  activeRequestCount += 1;
  notifyListeners();

  return () => {
    if (released) return;
    released = true;
    activeRequestCount = Math.max(0, activeRequestCount - 1);
    notifyListeners();
  };
};

export const trackRequest = (promise) => {
  const release = beginRequest();
  return Promise.resolve(promise).finally(release);
};
